// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"7994088e","81":"e9dc5a85","156":"f374f4f5","235":"01be07f8","310":"4ce0b588","394":"6181ee62","423":"25671f32","455":"9bf29d5e","538":"017976d5","725":"5164ccc7","739":"f8962771","853":"57551bd5","860":"8673aadd"}[chunkId] + ".chunk.js";
};